module.exports = function() {
  return new Worker(__webpack_public_path__ + "60f7c934f6bc48f283e3.worker.js");
};